<template>
  <div>
    <ReportMobileFrame
      v-if="$vuetify.breakpoint.smAndDown"
      :loading="isLoading"
      :empty="!isLoading && data.length === 0"
      empty-text="Pick a category to see performance."
    >
      <template #filters>
        <div class="report-dates-grid">
          <MobileDateField label="Start Date" :value="dates[0]" @input="onMobileDateChange(0, $event)" />
          <MobileDateField label="End Date" align="right" :value="dates[1] || dates[0]" @input="onMobileDateChange(1, $event)" />
        </div>
        <v-select
          :items="categories"
          item-text="name"
          item-value="id"
          v-model="selectedCategoryId"
          label="Category"
          outlined dense hide-details
          class="mt-2"
          @change="load"
        />
      </template>

      <ReportListRow v-for="(item, idx) in data" :key="item.productName + '-' + idx">
        <template #leading>
          <div class="report-rank">#{{ idx + 1 }}</div>
        </template>
        <template #title>{{ item.productName }}</template>
        <template #subtitle>{{ item.timesSold }} sold</template>
        <template #trailing>£{{ Number(item.totalCost || 0).toFixed(2) }}</template>
      </ReportListRow>
    </ReportMobileFrame>

    <template v-else>
    <v-row justify="center">
      <v-toolbar flat class="toolbar-container" height='100'>
        <div class="toolbar-content">
          <div class="toolbar-datepicker">
            <DateRangePicker :initialDates="dates" @blur="updateDates" />
          </div>

          <v-select
            :items="categories"
            item-text="name"
            item-value="id"
            v-model="selectedCategoryId"
            label="Category"
          />

          <v-spacer></v-spacer>

          <v-btn class="search-btn" type="button" color="success" v-on:click="load">
            SEARCH
          </v-btn>
        </div>
      </v-toolbar>
    </v-row>

    <v-row>
      <v-col>
        <h2 class="title-header">Category Performance</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="data"
          :loading="isLoading"
          item-key="productName"
          class="elevation-1 mt-5 flex-grow-1"
        >
          <template v-slot:[`item.totalCost`]="{ item }">
            £{{ item.totalCost.toFixed(2) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    </template>
  </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker.vue';
import ReportMobileFrame from '@/components/reports/ReportMobileFrame.vue';
import ReportListRow from '@/components/reports/ReportListRow.vue';
import MobileDateField from '@/components/reports/MobileDateField.vue';
import { reportService, categoryService } from '@/services';
import { userService } from '@/services';
import moment from 'moment';
import router from '../../router';

export default {
  name: 'CategoryPerformance',
  components: {
    DateRangePicker,
    ReportMobileFrame,
    ReportListRow,
    MobileDateField
  },
  data: () => ({
    dates: [moment().add(-1, 'M').toISOString().substr(0, 10), moment().toISOString().substr(0, 10)],

    categories: [],
    selectedCategoryId: null,

    isLoading: false,
    headers: [
      { text: 'Product', align: 'start', sortable: true, filterable: true, value: 'productName' },
      { text: 'Times Sold', align: 'start', sortable: true, filterable: true, value: 'timesSold' },
      { text: 'Total Cost', align: 'start', sortable: true, filterable: true, value: 'totalCost' },
    ],
    data: [],
  }),
  async created() {
    this.categories = await categoryService.get();

    if (userService.isStaff()) {
      router.push('/products');
    }
  },
  methods: {
    updateDates(newDates) {
      this.dates = newDates;
    },
    async load() {
      if (!this.selectedCategoryId) return;

      var startDate = this.dates[0];
      var endDate = this.dates[0];
      if (this.dates.length > 1)
        endDate = this.dates[1];

      this.isLoading = true;
      this.data = await reportService.getCategoryPerformanceReport(startDate, endDate, this.selectedCategoryId);
      this.isLoading = false;
    },
    onMobileDateChange(index, value) {
      if (!value) return;
      const next = this.dates.slice();
      while (next.length <= index) next.push(value);
      next[index] = value;
      if (index === 0) next[1] = value;
      this.dates = next;
      this.load();
    }
  },
};
</script>

<style lang="scss" scoped>
.toolbar-container {
  background: #fff !important;
  padding: 10px;
  height: auto;
  border-radius: 8px;
  border: 1px solid lighten(#7b5cd8, 30);
}

.toolbar-content {
  display: flex;
  flex-direction: row;
  width: 100%;

  .toolbar-datepicker {
    width: 250px;
  }
}

.title-header {
  text-align: center;
  padding: 20px;
  border-bottom: 2px solid #7b5cd8;
}

.report-rank {
  align-items: center;
  background: #e5e7eb;
  border-radius: 50%;
  color: var(--app-text);
  display: flex;
  font-size: 13px;
  font-weight: 700;
  height: 38px;
  justify-content: center;
  width: 38px;
}
</style>
